import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { scaffolderTranslationRef } from '@backstage/plugin-scaffolder';

export const scaffolderTranslations = createTranslationMessages({
  ref: scaffolderTranslationRef,
  messages: {
    'actionsPage.pageTitle': 'Self Service',
    'templateListPage.title': 'Self Service',
    'templateListPage.subtitle': 'Self Service templates in your organization',
    'templateListPage.pageTitle': 'Self Service',
    'templateWizardPage.title': 'Self Service',
    'templateWizardPage.subtitle':
      'Self Service templates in your organization',
    'templateWizardPage.pageTitle': 'Self Service',
  },
});
